export class OrderLineStats {
    public skuTotal: number = 0;
    public skuPacking: number = 0;
    public pending: number = 0;
    public total: number = 0;
}